// extracted by mini-css-extract-plugin
export default {"productDescription":"T4-z","featuredDescription":"U4-z","description":"V4-z","more":"W4-z","descriptionSku":"X4-z"};